import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useToastNotifications } from '../hooks/useToastNotifications';
import ToastNotification from './ToastNotification';

const ToastConsumer = () => {
  const { user } = useAuth();
  const { toasts, dismissToast, handleAction } = useToastNotifications(user?.id);

  return (
    <ToastNotification
      toasts={toasts}
      onDismiss={dismissToast}
      onAction={handleAction}
    />
  );
};

const ToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <ToastConsumer />
    </>
  );
};

export default ToastProvider;
